import { render } from "./LeeIndexAnchor.vue?vue&type=template&id=087708d2"
import script from "./LeeIndexAnchor.vue?vue&type=script&lang=js"
export * from "./LeeIndexAnchor.vue?vue&type=script&lang=js"

import "./LeeIndexAnchor.vue?vue&type=style&index=0&id=087708d2&lang=css"

import exportComponent from "F:\\leeao\\leeplus_docs_code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__